import { render, staticRenderFns } from "./MomentCard.vue?vue&type=template&id=7535d54c"
import script from "./MomentCard.vue?vue&type=script&lang=js"
export * from "./MomentCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports